import { FormItem, MenuPresets, TextInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import React from 'react';
import { RichTextAdvancedInput } from '../../../../../inputs';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { IWidgetParsedProps } from './util/getWidgetProps';

export interface ICodeLabelInputFormProps {
  widgetOptions: IWidgetParsedProps;
}

/**
 * Form per la configurazione del codice e dell'etichetta di alcuni widget.
 * Utilizzato per ridurre la code duplication che si era creata e dava
 * fallimento su sonarcloud
 */
export function CodeLabelInputForm(props: ICodeLabelInputFormProps) {
  const { widgetOptions: options } = props;
  return (
    <>
      <RowElement>
        <FormItem name="code" label="Codice">
          <TextInput name="code" />
        </FormItem>
        <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
      </RowElement>

      <FormItem name="label" label="Etichetta">
        <RichTextAdvancedInput
          name="label"
          rows={2}
          menus={MenuPresets.Minimal}
        />
      </FormItem>
    </>
  );
}
